module.exports = {"513428100":"普基镇","513428101":"荞窝镇","513428102":"螺髻山镇","513428103":"五道箐镇","513428104":"花山镇","513428105":"日都迪萨镇","513428106":"西洛镇","513428107":"夹铁镇","513428203":"黎安乡","513428206":"大坪乡","513428213":"特兹乡","513428218":"瓦洛乡","513428227":"大槽乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513428.json
// module id = 2569
// module chunks = 0